import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import axiosInstance from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Helmet } from 'react-helmet';
import LoadingScreen from '../../components/LoadingScreen';
import { useBlogContext } from '../../../fetchdata/BlogContext';

const AllPlans = () => {


  const {
    Headers,

  } = useBlogContext();

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Buyloading, setBuyLoading] = useState(false);
  const [Local, setLocal] = useState(0);

  // Fetch all plans data
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/all-plan`);
      setData(response.data?.plan);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Buy plan function
  const buyNow = async (planId, totalAmount, userData) => {


    try {
      const mydata = {
        userId: '',
        planId,
        totalAmount,
        razorpay_order_id: '',
        razorpay_payment_id: '',
        razorpay_signature: '',
        note: '',
        Local,
        userData
      };

      setBuyLoading(true);
      const { data } = await toast.promise(
        axiosInstance.post(`/buy-plan`, mydata),
        {
          loading: 'Buying plan...',
          success: 'Plan bought successfully!',
          error: 'Failed to buy plan.',
        }
      );

      const { success, message } = data;
      if (success) {
        fetchData();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setBuyLoading(false);
    }
  };

  // Helper function to check if the category names match
  const areCategoriesEqual = (categories1, categories2) => {
    return categories1.map((category1) => {
      const matchedCategory = categories2.find((category2) => category2.name === category1.name);
      return matchedCategory ? 'Yes' : 'No';
    });
  };

  // Create a table structure for comparison
  const renderComparisonTable = () => {
    if (data.length < 2) {
      return (
        <div className="text-center">
          <p>Comparison is available only for multiple plans.</p>
        </div>
      );
    }

    // Get all unique categories across all plans
    const allCategories = Array.from(
      new Set(data.flatMap((plan) => plan.Category.map((category) => category.name)))
    );

    return (
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ maxWidth: '20%' }} className='bg-light' >Feature / Plan</th>
            {data.map((plan) => (
              <th key={plan._id} className='text-center bg-light' >{plan.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {allCategories.map((categoryName) => (
            <tr key={categoryName}>
              <td style={{ maxWidth: '20%' }}  >{categoryName}</td>
              {data.map((plan) => {
                const hasFeature = plan.Category.some(
                  (category) => category.name === categoryName
                );
                return (
                  <td key={plan._id} className="text-center">
                    {hasFeature ? 'Yes' : 'No'}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const handleScroll = () => {
    document.getElementById('allplan').scrollIntoView({
      behavior: 'smooth',
    });
  };


  return (
    <>

      <Helmet>
        <title>All Plans | {window.location.hostname}</title>
      </Helmet>
      <div className='bg-light border-bottom'>
        <div className="container">
          <div className="d-flex gap-4 justify-content-between p-4 align-items-center">
            {/* Logo */}
            <Link
              className="navbar-brand flex-shrink-0 flex-fill "
              to="/"
              style={{ borderRadius: 5, aspectRatio: "120/25", height: 40 }}
            >
              {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                <img
                  src={Headers.meta_logo}
                  width={120}
                  alt="logo"
                  style={{
                    maxHeight: 50,
                    width: "auto",
                    filter: "grayscale(0)",
                    mixBlendMode: "multiply",
                  }}
                />
              ) : (
                <div
                  className="card-1 skeleton"
                  style={{
                    borderRadius: 5,
                    aspectRatio: "142/25",
                    width: "100%",
                    height: 50,
                  }}
                ></div>
              )}
            </Link>
            <Link className="btn btn-dark btn-md rounded-xl" to={'/'} >
              <i class="ri-arrow-left-circle-line text-white"></i> Back</Link>

          </div>
        </div>
      </div>


      <div className="user-dasboard bg-white">
        <div className="container pt-4">

          <div className="row pb-4 mt-4 pt-4">


<div className='col-md-7'>
  <h5 className='text-theme'>All Plans</h5>
  <h1>Grow Your Business with Ontech Digital</h1>
  <h4 className='text-theme'>Business Listing & Marketing Solutions</h4>
  <ul>
    <li>Search Visibility Boost</li>
    <li>Online Business Catalogue</li>
    <li>Digital Payment Integration</li>
    <li>Smart Lead Management System</li>
    <li>Competitor Performance Insights</li>
    <li>Priority Support from Our Team</li>
  </ul>
  <Link className="btn btn-primary" to="#allplan" onClick={handleScroll}>
    See All Plan Pricing
  </Link>
</div>

   
   <div className='col-md-5'>
  <img src="assets/img/justdial.avif" width={'100%'} alt='Ontech Plan Banner' className=' rounded' />
</div>

            <div id="main-content" className="w-100">
              <br />    <br />
              <div className="text-center container" id="allplan">
                <h2 className="text-uppercase mb-4">All Plans</h2>
<p className="text-center">
  At Ontech Digital, we offer a range of flexible and affordable business plans designed to boost your online presence, attract more customers, and grow your business faster.
</p>
              </div>

              {loading ? (
                <LoadingScreen />
              ) : (
                <div className="bg-transparent border-0 mb-4">
                  <div className="row">
                    {data.length > 0 ? (
                      data.map((row) => (
                        <div key={row._id} className="col-12 col-lg-6 col-xl-4">
                          <div className="card bg-light mb-4 mb-xl-0 h-100" >
                            <div className="card-header bg-transparent border border-gray-100 py-5 px-4" style={{ flex: '1' }}>
                              <div className="d-flex mb-3">
                                <span className="h5 mb-0">Rs</span>
                                <span className="price display-3 mb-0">{row.price}</span>
                                <span className="h6 fw-normal align-self-end">/ {row.validity} days</span>
                              </div>
                              <h4 className="mb-3 text-black">{row.name}</h4>
                              <p className="fw-normal mb-0">
                                <ul>
                                  {row.Category.length !== 0 &&
                                    row.Category.map((category) => (
                                      <li key={category._id}>{category.name}</li>
                                    ))}
                                </ul>
                              </p>
                            </div>

                            <div className="card-footer border-gray-100 d-grid px-4 pb-4">
                              {!Buyloading ? (
                                <Link
                                  className="btn btn-primary"
                                  to={`/checkout-plan/${row._id}`}
                                >
                                  Buy Plan
                                </Link>
                              ) : (
                                <button className="btn btn-primary btn-sm" type="button" disabled>
                                  <span className="ms-1">Loading...</span>
                                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p>No plans available at the moment.</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className='overflow-auto mt-4 pt-4'>
                <br />
                {renderComparisonTable()}
              </div>



            <div className="row mt-4">
  <div className="col-md-12 col-12 pb-4">
    <h2 className="text-center">Benefits of Ontech Digital</h2>
  </div>

  <div className="col-md-4 col-12 mb-4">
    <div className="d-flex px-3 py-3 gap-2 align-items-center rounded blurbbg" style={{ background: "#fff4f2", height: "100%" }}>
      <img alt="Visibility Icon" width="40px" height="40px" src="https://cdn-icons-png.flaticon.com/512/1055/1055646.png" />
      <div className="col">
        <h5 className="text-dark">Increased Visibility</h5>
        <p className="fw-light text-grey p-0 m-0">
          Get discovered by thousands of potential customers in your area.
        </p>
      </div>
    </div>
  </div>

  <div className="col-md-4 col-12 mb-4">
    <div className="d-flex px-3 py-3 gap-2 align-items-center rounded blurbbg" style={{ background: "#fff4f2", height: "100%" }}>
      <img alt="Lead Icon" width="40px" height="40px" src="https://cdn-icons-png.flaticon.com/512/2936/2936951.png" />
      <div className="col">
        <h5 className="text-dark">Verified Leads</h5>
        <p className="fw-light text-grey p-0 m-0">
          Receive leads from customers actively looking for your services.
        </p>
      </div>
    </div>
  </div>

  <div className="col-md-4 col-12 mb-4">
    <div className="d-flex px-3 py-3 gap-2 align-items-center rounded blurbbg" style={{ background: "#fff4f2", height: "100%" }}>
      <img alt="Support Icon" width="40px" height="40px" src="https://cdn-icons-png.flaticon.com/512/456/456212.png" />
      <div className="col">
        <h5 className="text-dark">Dedicated Support</h5>
        <p className="fw-light text-grey p-0 m-0">
          Our expert team helps you set up, optimize, and grow your listings.
        </p>
      </div>
    </div>
  </div>
</div>


<div className="row mt-4">
  <div className="col-md-12 col-12 pb-4">
    <h2 className="text-center">How It Works</h2>
  </div>

  <div className="col-md-4 col-12 mb-4">
    <div className="d-flex px-3 py-3 gap-2 align-items-center rounded blurbbg" style={{ background: "#fff4f2", height: "100%" }}>
      <img alt="Plan Selection" width="40px" height="40px" src="https://cdn-icons-png.flaticon.com/512/942/942748.png" />
      <div className="col">
        <h5 className="text-dark">Step 1: Choose Your Plan</h5>
        <p className="fw-light text-grey p-0 m-0">
          Select a plan that matches your business goals and budget.
        </p>
      </div>
    </div>
  </div>

  <div className="col-md-4 col-12 mb-4">
    <div className="d-flex px-3 py-3 gap-2 align-items-center rounded blurbbg" style={{ background: "#fff4f2", height: "100%" }}>
      <img alt="List Business" width="40px" height="40px" src="https://cdn-icons-png.flaticon.com/512/1514/1514716.png" />
      <div className="col">
        <h5 className="text-dark">Step 2: Add Your Business Details</h5>
        <p className="fw-light text-grey p-0 m-0">
          Create your listing with photos, services, and contact info.
        </p>
      </div>
    </div>
  </div>

  <div className="col-md-4 col-12 mb-4">
    <div className="d-flex px-3 py-3 gap-2 align-items-center rounded blurbbg" style={{ background: "#fff4f2", height: "100%" }}>
      <img alt="Get Leads" width="40px" height="40px" src="https://cdn-icons-png.flaticon.com/512/1828/1828817.png" />
      <div className="col">
        <h5 className="text-dark">Step 3: Start Getting Leads</h5>
        <p className="fw-light text-grey p-0 m-0">
          Customers will find your business and contact you directly.
        </p>
      </div>
    </div>
  </div>
</div>



<section className="my-4 py-4">
  <h3 className="text-start mb-3">Frequently Asked Questions</h3>
  <div className="accordion" id="accordionID0">

    <div className="accordion-item mb-2 border rounded overflow-hidden">
      <div className="accordion-header">
        <h4
          className="accordion-button h3 collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#faq1"
          aria-expanded="false"
          aria-controls="faq1"
          style={{ fontSize: 20, fontWeight: 600 }}
        >
          1. How do I list my business on Ontech Digital?
        </h4>
      </div>
      <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#accordionID0">
        <div className="accordion-body">
          Simply choose a plan, sign up, and fill in your business details. Our team will review and activate your listing.
        </div>
      </div>
    </div>

    <div className="accordion-item mb-2 border rounded overflow-hidden">
      <div className="accordion-header">
        <h4
          className="accordion-button h3 collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#faq2"
          aria-expanded="false"
          aria-controls="faq2"
          style={{ fontSize: 20, fontWeight: 600 }}
        >
          2. What kind of businesses can register?
        </h4>
      </div>
      <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#accordionID0">
        <div className="accordion-body">
          Any local service provider, shop, professional, or company can list with us. From plumbers to salons — everyone is welcome.
        </div>
      </div>
    </div>

    <div className="accordion-item mb-2 border rounded overflow-hidden">
      <div className="accordion-header">
        <h4
          className="accordion-button h3 collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#faq3"
          aria-expanded="false"
          aria-controls="faq3"
          style={{ fontSize: 20, fontWeight: 600 }}
        >
          3. How do I get leads?
        </h4>
      </div>
      <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#accordionID0">
        <div className="accordion-body">
          Once listed, customers searching for your services will find your profile and can contact you directly or through our smart lead system.
        </div>
      </div>
    </div>

    <div className="accordion-item mb-2 border rounded overflow-hidden">
      <div className="accordion-header">
        <h4
          className="accordion-button h3 collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#faq4"
          aria-expanded="false"
          aria-controls="faq4"
          style={{ fontSize: 20, fontWeight: 600 }}
        >
          4. Can I upgrade or cancel my plan?
        </h4>
      </div>
      <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#accordionID0">
        <div className="accordion-body">
          Yes, you can upgrade anytime. Cancellation is also possible based on our terms & refund policies.
        </div>
      </div>
    </div>

  </div>
</section>



            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default AllPlans;
